import { EType, IMedia } from '../../../../../packages/Carousel/shared/types/media';
import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const thumbnails: TComputedPropMapper<Array<IMedia | null> | null> = ({ offer: { isTop3, photos } }) => {
  if (!isTop3 || photos.length < 2) {
    return null;
  }

  const media = photos
    .map(photo => ({
      type: photo.isLayout ? EType.Layout : EType.Photo,
      url: photo.thumbnailUrl,
    }))
    .slice(1);

  return new Array(3).fill(null).map((_, index) => media[index] || null);
};
